// Converts the current route path and query into a friendly title
export function getDynamicTitle(path: string): string {
    const p = path.toLowerCase()
    
    // --- Membership / Account
    if (p.startsWith('/register') && p.includes('personid') && p.includes('guid'))
        return 'My Membership'
    if (p === '/register' || p.startsWith('/register?'))
        return 'Register'
    
    // --- Match Detail
    if (p.startsWith('/match_detail')) return 'Match Review'
    
    // --- How / Help
    if (p.startsWith('/how')) return 'Learn How'
    
    // --- Info / Debug
    if (p.startsWith('/info') && p.includes('debug_dump')) return 'Debug Dump'
    
    // --- Document pages
    if (p.startsWith('/doc') && p.includes('tsandcs')) return 'Terms & Conditions'
    if (p.startsWith('/doc') && p.includes('privacy_policy')) return 'Privacy Policy'
    if (p.startsWith('/doc') && p.includes('cookies')) return 'Cookie Policy'
    
    // --- Player-related
    if (p.startsWith('/player_detail')) return 'Profile'
    if (p.startsWith('/player_admin')) return 'Player Admin'
    
    // --- Dashboard Tabs
    if (p.startsWith('/dashboard') && p.includes('community')) return 'Community'
    
    // --- Configurations
    if (p.startsWith('/config') && p.includes('email_config')) return 'Control Centre'
    
    // --- Subscription / Payments
    if (p.startsWith('/subscribe') && p.includes('add_payment_method')) return 'Payment Methods'
    
    // --- Following / Followers
    if (p.startsWith('/following')) return 'Followers'
    
    // --- Performance stats
    if (p.startsWith('/most_improved')) return 'Most Improved'
    
    // --- Fallback
    return 'Dynamic Content'
}